import { render, staticRenderFns } from "./Promos.vue?vue&type=template&id=6f9d1a8e"
import script from "./Promos.vue?vue&type=script&lang=js"
export * from "./Promos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports